import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const HelloBox = styled.div`
    color: ${colors.BLUE};
    font-family: Courgette, cursive;
    align-self: flex-end;
    margin-right: 100px;
    display: flex;
    align-items: center;
`;

export const UserHeader = styled.div`
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    padding: 25px 100px;
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12);
    animation: buttonsAnimation 1000ms ease-in forwards;

    @media (max-width: 1200px) {
        flex-direction: column;
        padding: 25px 60px;
    }

    @media (max-width: 800px) {
        padding: 25px 40px;
    }

    @media (max-width: 400px) {
        padding: 25px 20px;
    }

    @keyframes buttonsAnimation {
        0% {
          opacity: 0;
          transform: scale(0.98);
        }
        100% {
          opacity: 100;
          transform: scale(1);
        }
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: ${colors.WHITE};
    transition: box-shadow 200ms ease-in;
    margin: 10px;

    span{
        color: #333333 !important;
        margin-top: 5px;
        line-height: 1.5;
    }

    @media (max-width: 700px) {
        width: 40%;
        margin-bottom: 15px;
    }
`;

export const ImageWrapper = styled.div`
    height: 170px;
    width: 170px;
    border: solid 3px ${colors.BLUE};
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    object-fit: cover;
`;

export const UserButton = styled.button`
    font-size: 22px;
    background-color: ${colors.BLUE};
    color: ${colors.WHITE};
    padding: 0;
    border-radius: 12px;
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12);
    animation: buttonsAnimation 1000ms ease-in forwards;

    @media (min-width: 1200px) {
        &:hover{
            cursor: pointer;
            box-shadow: 0 8px 8px -4px rgba(0,0,0,.3), 0 8px 8px 0 rgba(0,0,0,.2), 0 2px 16px 0 rgba(0,0,0,.15);
        }
    }

    @keyframes buttonsAnimation {
        0% {
          opacity: 0;
          transform: scale(0.98);
        }
        100% {
          opacity: 100;
          transform: scale(1);
        }
    }
`;

export const ButtonsWrapper = styled.div`
    display: flex;

    @media (max-width: 1200px) {
        margin-top: 25px;
    }

    @media (max-width: 700px) {
        flex-wrap: wrap;
        justify-content: space-between;
        width: 210px;
    }
`;

export const UserDataBigWrapper = styled.div`
    display: flex;
    width: 100%;

    @media (max-width: 750px) {
        flex-direction: column;
    }
`;

export const UserDataHalf = styled.div`
    width: 50%;

    @media (max-width: 750px) {
        width: 100%;
    }
`;

export const UserDataWrapper = styled.div`
    margin-bottom: 15px;
`;

export const UserLabel = styled.label`
    color: ${colors.BLUE};
    font-weight: bold;
    font-style: italic;

    &:after { 
        content: ":";
    }
`;

export const UserData = styled.p`
    color: ${(props) => props.userStatus === 'APPROVED' ? colors.GREEN : props.userStatus === 'READY_FOR_REVIEW' ? colors.YELLOW : '#333333'};
`;

export const SettingsHeader = styled.div`
    width: 100%;
    text-align: center;
    position: relative;
`;

export const Title = styled.h2`
    color: ${colors.BLUE};
    text-transform: uppercase;
`;

export const DataWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`;